export type SignOutHook = () => Promise<void> | void;

/**
 * Registry of cleanup tasks that must run while the session is still valid
 * (RLS needs auth.uid()), e.g. removing the device push token before signing out.
 * Hooks are responsible for their own error logging; failures never block sign-out.
 */
export function createSignOutHooks() {
  const hooks = new Set<SignOutHook>();

  return {
    register(hook: SignOutHook): () => void {
      hooks.add(hook);
      return () => {
        hooks.delete(hook);
      };
    },

    async runAll(): Promise<void> {
      await Promise.allSettled([...hooks].map(async (hook) => hook()));
    },
  };
}
